<div class="global-search" #globalSearch *featureToggleEnabled="'a-global-search'">
  <i *ngIf="!isSearchFocused; else expandedSearch" (click)="onSearchClick(); $event.stopPropagation()" ui-icon uiType="search"></i>
  <ng-template #expandedSearch>
    <div class="search-actions" [uiVisible]="shouldShowPopover" [uiContent]="resultTemplate" ui-popover uiOverlayClassName="without-arrow" uiPlacement="bottomRight" uiTrigger="click">
      <i ui-icon uiType="search"></i>
      <input
        class="search-input"
        [(ngModel)]="searchTerm"
        [placeholder]="'search' | localize"
        (ngModelChange)="onSearchTermChange()"
        aria-label="Global Search"
        data-test-id="nav-bar-global-search-input" />
      <ui-divider uiType="vertical"></ui-divider>
      <span class="current-facet" [(uiVisible)]="isFacetMenuOpen" [uiDropdownMenu]="menucl" ui-dropdown uiTrigger="click" uiPlacement="bottomRight">
        {{ currentFacet$ | async | localize }}
        <i ui-icon uiType="down"></i>
      </span>
      <ui-dropdown-menu #menucl="uiDropdownMenu">
        <ul class="facet-option-menu" #facetMenu style="min-width: 140px" ui-menu>
          <li *ngFor="let facet of facetOptions$ | async" (click)="changeFacet(facet)">
            <span class="facet-option">{{ facet | localize }}</span>
          </li>
        </ul>
      </ui-dropdown-menu>
    </div>
    <ng-template #resultTemplate>
      <div class="results" #resultsPopover [ngStyle]="{ 'max-height.px': calculateMaxHeight(), 'overflow-y': 'auto' }">
        <ng-container *ngIf="!gettingSearchData && !!searchTerm">
          <search-results></search-results>
          <no-search-items-found></no-search-items-found>
        </ng-container>
        <ng-container *ngIf="!!gettingSearchData">
          <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 1 }"></ui-skeleton>
          <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 3 }"></ui-skeleton>
          <ui-skeleton [uiActive]="true" [uiParagraph]="{ rows: 2 }"></ui-skeleton>
        </ng-container>
      </div>
    </ng-template>
  </ng-template>
</div>
